import { socketStream } from '../../model/socket-stream.js';
import { statisticsStore } from '../../model/statistics-store.js';
import { AccountStatistics } from '../../model/entities/account_statistics.js';
export default {
	namespaced: true,
	state: {
		callbacks: {},
		// cropped data
        statBySymbol: {},
        monthStat:{}
	},
	mutations: {
		setAllItems(state, data) {
			for (let i = 0; i < data.length; i++) {
				statisticsStore.storeStat(data[i].Symbol, data[i].IsPrimary, data[i].Statistics);
                let symbolCode = (data[i].Symbol && data[i].Symbol.length) ? data[i].Symbol : '_';
                state.statBySymbol[symbolCode] = AccountStatistics.cropStatistics(data[i].Statistics);
			}
			for (let i = 0; i < data.length; i++)
				callUpdateHandlers(state.callbacks, data[i].Symbol, data[i].IsPrimary, true);
		},
		setItem(state, data) {
			addOrUpdateStatByAccount(state, data);
        },
        setMonthStat(state, data) {
            state.monthStat = data;
        },
		saveCallback(state, data) {
			let key = data.symbol ? data.symbol : '_';
			if (!state.callbacks[key])
				state.callbacks[key] = [ data.callback ];
			else
				state.callbacks[key].push(data.callback);
		},
		removeCallback(state, callerId) {
			for (let key in state.callbacks) {
				for (let i = 0; i < state.callbacks[key].length; i++) {
					if (state.callbacks[key][i].id !== callerId) continue;
					state.callbacks.splice(i, 1);
					return;
				}
			}
		}
	},
	getters: {
		getStatistics(state) {
			return (symbol) => {
				return statisticsStore.getStat(symbol);
			}
		},
		getPrimaryStatistics(state) {
			return statisticsStore.getStat('');
		},
		getCroppedStatBySymbol(state) {
			return (symbol) => {
				if (!symbol || !symbol.length)
                    symbol = '_';
				return state.statBySymbol[symbol];
			}
        },
        getMonthStatByDate(state) {
            return state.monthStat;
        },
		getMonthStat(state) {
			return (symbol, date, index) => {
				return statisticsStore.getMonthStat(symbol, date, index);
			}
    },
    getYearStat(state) {
			return (symbol, date, index) => {
				return statisticsStore.getYearStat(symbol, date, index);
			}
    },
        getPeriod(state) {
			return (symbol) => {
				return statisticsStore.getPeriod(symbol);
			}
        },
        getMonthsInYear(state) {
            return (symbol, year) => {
				return statisticsStore.getMonthsInYear(symbol, year);
			}
        },
        getMonthlyPercent(state) {
            return (symbol) => {
                return statisticsStore.getMonthlyPercent(symbol);
            }
        },
        getMonthProfitAndDd(state) {
            return (symbol) => {
                return statisticsStore.getMonthProfitAndDd(symbol);
            }
        },
        getMonthProfitStrategy(state) {
            return (symbol) => {
                return statisticsStore.getMonthProfitStrategy(symbol);
            }
        },
        getMonthlyPercentByDaily(state) {
            return (symbol) => {
                return statisticsStore.getMonthlyPercentByDaily(symbol);
            }
        }
	},
	actions: {
		initialize(state) {
			let subMsg = JSON.stringify({
				ClassName: "AccountStatisticsSubscription"
			});
			socketStream.addChannelHandler('Statistics', 'accountstat', (stat) => {
				if (stat[0] == 'update')
					state.commit('setItem', stat[1][0]);
                else
					state.commit('setAllItems', stat[1]);
			})
			socketStream.subscribeOnConnect(() => {
				socketStream.socket.send(subMsg);
			});
		},
		// payload: { symbol:"", callback: { id: "210841", handler: function }}
		// handler: function (isFirstUpdate) { ... return; }
		subscribeOnUpdate(state, payload) {
			state.commit('saveCallback', payload);
		},
		// payload: "210841"
		unsubscribeFromUpdate(state, payload) {
			state.commit('removeCallback', payload);
        },
        monthStat(store, date) {
            let statMonth = statisticsStore.getMonthStat('', date);
            store.commit('setMonthStat', statMonth);
        }
	}
}

function addOrUpdateStatByAccount(state, data) {
    let oldItem = statisticsStore.getStat(data.Symbol, data.IsPrimary);
	let itemExists = true;
	if (!oldItem) {
		oldItem = data.Statistics;
		itemExists = false;
	}
    //console.log(JSON.stringify(data));
    
	let newStat = data.Statistics;

	// DailyRecords
	if (!oldItem.DailyRecords.length)
		oldItem.DailyRecords = newStat.DailyRecords;
	else {
		let oldDaily = oldItem.DailyRecords;
		let newDaily = newStat.DailyRecords;
		if (oldDaily[oldDaily.length - 1].Date == newDaily[newDaily.length - 1].Date)
			oldDaily[oldDaily.length - 1] = newDaily[newDaily.length - 1];
		else
			oldDaily.push(newDaily[newDaily.length - 1])
    }

    if (!oldItem.HourlyRecords.length)
		oldItem.HourlyRecords = newStat.HourlyRecords;
	else {
		let oldDaily = oldItem.HourlyRecords;
		let newDaily = newStat.HourlyRecords;
		if (oldDaily[oldDaily.length - 1].Date == newDaily[newDaily.length - 1].Date)
			oldDaily[oldDaily.length - 1] = newDaily[newDaily.length - 1];
		else
			oldDaily.push(newDaily[newDaily.length - 1])
	} 

	// ProfitOn1000
	if (!oldItem.ProfitOn1000.length)
		oldItem.ProfitOn1000 = newStat.ProfitOn1000;
	else {
		let oldPl = oldItem.ProfitOn1000;
		let newPl = newStat.ProfitOn1000;
		if (oldPl[oldPl.length - 1].time == newPl[newPl.length - 1].time)
			oldPl[oldPl.length - 1] = newPl[newPl.length - 1];
		else
			oldPl.push(newPl[newPl.length - 1])
	}

	statisticsStore.storeStat(data.Symbol, data.IsPrimary, oldItem);
	callUpdateHandlers(state.callbacks, data.Symbol, data.IsPrimary, !itemExists);

	let symbolCode = (data.Symbol && data.Symbol.length) ? data.Symbol : '_';
	// может быть нужен Vue.set(state, 'statBySymbol', )
	state.statBySymbol[symbolCode] = data.Statistics;
}

function callUpdateHandlers(callbacks, symbol, isPrimary, isFirstObtained) {
	let handlerKey = isPrimary ? '_' : symbol;
	let handlers = callbacks[handlerKey];
	if (!handlers || !handlers.length) return;
	
	for (let i = 0; i < handlers.length; i++) {
        handlers[i].handler(isFirstObtained);
    }	
}

/* 
HOWTO: подписаться на получение статистики по основному счету (symbol = '')

function onPrimStatUpdated() {
	// some logic here ...
}

this.$store.dispatch("accountstat/subscribeOnUpdate", 
       { symbol: '', callback: { id: 'myComponent', (isFirstObtained) => { onPrimStatUpdated(); } } });

// если компонент временный, если в какой-то момент я хочу отписаться от события - получение статистики

this.$store.dispatch("accountstat/subscribeOnUpdate", 
       { symbol: 'EURUSD', callback: { id: 'myComponentEURUSD', (isFirstObtained) => { onPrimStatUpdated(); } } });
// ...
this.$store.dispatch("accountstat/unsubscribeFromUpdate", "EURUSD");
*/
